module.exports = __webpack_public_path__ + "img/cancelado_c.5a0a3777.png";